export default __webpack_public_path__ + "static/media/icon-Hub-Files.c5e0990d.svg";